// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2AGok","inner":"Form_inner__3uONb","range":"Form_range__PMW8B","name":"Form_name__1r9FS","actions":"Form_actions__3_TkR"};